import React from "react";
import { useNavigate } from "react-router-dom";
import heroImage from "../Assets/L3.jpg"; // Replace with your actual image

const Landing = () => {
  const navigate = useNavigate();

  return (
    <section className="flex flex-col-reverse md:flex-row items-center pt-20 md:pt-32 justify-center min-h-[60vh] bg-gradient-to-r from-gray-50 to-gray-100 px-6 md:px-16 py-6 md:gap-12">
      
      {/* Left Side - Content */}
      <div className="w-full md:w-2/5 text-center md:text-left">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
          Welcome to <span className="text-blue-600">JCS Global</span>
        </h1>
        <p className="mt-4 text-gray-600 text-lg leading-relaxed">
          At JCS Global, we offer a wide range of advanced solutions including Smart Automation, Electronics Trading, and Innovative Intelligence. Our services also encompass Call Centers, Network Services, and more to enhance your everyday experiences.
        </p>

        {/* CTA Buttons */}
        <div className="mt-6 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <button 
            className="bg-blue-600 text-white px-6 py-3 rounded-lg text-lg sm:text-xl font-medium hover:bg-blue-700 hover:scale-105 transition-transform duration-300 w-full sm:w-auto"
            onClick={() => navigate("/shop-by-catagories")}
          >
            Explore Services
          </button>
          <button 
            className="bg-gray-800 text-white px-6 py-3 rounded-lg text-lg sm:text-xl font-medium hover:bg-gray-900 hover:scale-105 transition-transform duration-300 w-full sm:w-auto"
            onClick={() => navigate("/contact-us")}
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Right Side - Image (60% width on large screens) */}
      <div className="w-full md:w-3/5 flex justify-center mb-6 md:mb-0">
        <img 
          src={heroImage} 
          alt="JCS Global Overview" 
          className="w-full md:w-[60vw] rounded-lg shadow-lg transition-transform duration-300"
        />
      </div>

    </section>
  );
};

export default Landing;
